import * as Yup from "yup";

export const CashBackValidation = Yup.object().shape({
  activityCodes: Yup.object().required("Required"),
  contactName: Yup.string().min(1, "Too Short!").required("Required"),
  contactEmail: Yup.string()
  .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/),
  contactPhone: Yup.string()
  .matches(/^[5|7][0-9]{8}$/)
  .required("Required"),
  companyCode: Yup.string().min(1, "Too Short!").required("Required"),

  companyWebSite: Yup.string(),
  companyName: Yup.string(),
  agree: Yup.boolean().test({
    test: (value) => !!value,
  }),
});
